import script from "./StaffMap.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffMap.vue?vue&type=script&setup=true&lang=js"

import "./StaffMap.vue?vue&type=style&index=0&id=0fa99401&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa99401"]])

export default __exports__